module.exports = __webpack_public_path__ + "img/logo_resize_grand_lukto.edaf044b.png";